import { render, staticRenderFns } from "./AccionesCliente.vue?vue&type=template&id=5c6edeb2"
import script from "./AccionesCliente.vue?vue&type=script&lang=js"
export * from "./AccionesCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports